import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RBACService } from 'src/app/shared/rbac.service';

@Component({
  selector: 'app-contractors-importer',
  templateUrl: './contractors-importer.component.html',
  styleUrls: ['./contractors-importer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContractorsImporterComponent implements OnInit {
  constructor(public rbac: RBACService, private router: Router) {}

  ngOnInit() {
    // Check RBAC permission
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_CONTRACTORS,
            RBACService.RBAC_A.A_CREATE
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to import contractors.'
      );
      this.router.navigate(['/contractors']);
      return;
    }
  }

  protected readonly RBACService = RBACService;
}
